import React, { useEffect, useState } from 'react';
import { SelectValue } from 'antd/lib/select';
import Select from 'src/components/common/Select';

const { Option } = Select;

const MAX_COMPETITOR_COUNT = 5;

type CompetitorFilterProps = {
  competitors: string[];
  onUpdate: (value: string[]) => void;
};

const CompetitorFilter: React.FC<CompetitorFilterProps> = ({ competitors, onUpdate }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [sortedCompetitors, setSortedCompetitors] = useState<string[]>([]);

  useEffect(() => {
    setSortedCompetitors([...competitors].sort((a, b) => a.localeCompare(b)));
  }, [competitors]);

  const handleCompetitors = (value: SelectValue) => {
    const selectedCompetitors = Array.isArray(value) ? value.map(String) : [];
    onUpdate(selectedCompetitors);
    setSelectedOptions(selectedCompetitors);
  };

  return (
    <Select
      mode={'multiple'}
      showArrow={true}
      placeholder="Select Competitors"
      onChange={handleCompetitors}
      allowClear
      maxTagCount={1}
    >
      {sortedCompetitors.map((option, i: number) => (
        <Option
          disabled={selectedOptions.length >= MAX_COMPETITOR_COUNT && !selectedOptions.includes(option)}
          value={option}
          key={`competitor-name-${option}-${i}`}
        >
          {option}
        </Option>
      ))}
    </Select>
  );
};

export default CompetitorFilter;
